var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Mutation as ApolloMutation, } from 'react-apollo';
import { withUpdates } from '@loona/core';
import { LoonaContext } from '../context';
var Mutation = /** @class */ (function (_super) {
    __extends(Mutation, _super);
    function Mutation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Mutation.prototype.render = function () {
        var _this = this;
        var children = this.props.children;
        return (React.createElement(LoonaContext.Consumer, null, function (_a) {
            var loona = _a.loona;
            return (React.createElement(ApolloMutation, __assign({}, _this.props), function (mutation, result) {
                return children(wrapMutation(loona, mutation, _this.props.mutation), result);
            }));
        }));
    };
    Mutation.propTypes = ApolloMutation.propTypes;
    return Mutation;
}(React.Component));
export { Mutation };
export function wrapMutation(loona, mutate, doc) {
    if (!loona) {
        throw new Error('No Loona No Mutation!');
    }
    return function (mutation) {
        var config = doc
            ? __assign({ mutation: doc }, mutation) : __assign({}, mutation);
        var promise = mutate(withUpdates(config, loona.manager));
        loona.wrapMutation(promise, config, false);
        return promise;
    };
}
//# sourceMappingURL=mutation.js.map